interface IStorageItem {
  [key: string]: any;
}

const localStorage = typeof window !== 'undefined' && window.localStorage;
const sessionStorage = typeof window !== 'undefined' && window.sessionStorage;

export const addItemToLocalStorage = (key: string, value: any): void => {
  if (localStorage) {
    localStorage.setItem(
      key,
      typeof value !== 'string' ? JSON.stringify(value) : value
    );
  }
};

export const addItemToSessionStorage = (key: string, value: any): void => {
  if (sessionStorage) {
    sessionStorage.setItem(
      key,
      typeof value !== 'string' ? JSON.stringify(value) : value
    );
  }
};

export const getItemFromLocalStorage = (
  key: string
): IStorageItem | null | undefined => {
  if (localStorage) {
    try {
      const item: string = localStorage.getItem(key);
      return JSON.parse(item);
    } catch (err) {
      console.error('LOCALSTORAGE', err);

      return undefined;
    }
  }
};

export const getItemFromSessionStorage = (
  key: string
): IStorageItem | null | undefined => {
  if (sessionStorage) {
    try {
      const item: string = sessionStorage.getItem(key);
      return JSON.parse(item);
    } catch (err) {
      console.error('SESSIONSTORAGE', err);

      return undefined;
    }
  }
};

export const removeItemFromLocalStorage = (key: string): void => {
  if (localStorage) {
    localStorage.removeItem(key);
  }
};

export const removeItemFromSessionStorage = (key: string): void => {
  if (sessionStorage) {
    sessionStorage.removeItem(key);
  }
};
